
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/place/[id]/mubinso",
      function () {
        return require("private-next-pages/place/[id]/mubinso/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/place/[id]/mubinso"])
      });
    }
  